import React from 'react';

const TabPanel = ({ value, index, children, className, ...rest }) => {
  return (
    value === index && (
      <div className={className} {...rest}>
        {children}
      </div>
    )
  );
};

export default TabPanel;
